import { render, staticRenderFns } from "./productionSummary.vue?vue&type=template&id=317e1236"
import script from "./productionSummary.vue?vue&type=script&lang=js"
export * from "./productionSummary.vue?vue&type=script&lang=js"
import style0 from "./productionSummary.vue?vue&type=style&index=0&id=317e1236&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports